/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyTypeDto } from './PropertyTypeDto';
import {
    PropertyTypeDtoFromJSON,
    PropertyTypeDtoFromJSONTyped,
    PropertyTypeDtoToJSON,
    PropertyTypeDtoToJSONTyped,
} from './PropertyTypeDto';

/**
 * 
 * @export
 * @interface PropertyTypeTreeDto
 */
export interface PropertyTypeTreeDto {
    /**
     * 
     * @type {Array<PropertyTypeDto>}
     * @memberof PropertyTypeTreeDto
     */
    propertyTypes: Array<PropertyTypeDto>;
}

/**
 * Check if a given object implements the PropertyTypeTreeDto interface.
 */
export function instanceOfPropertyTypeTreeDto(value: object): value is PropertyTypeTreeDto {
    if (!('propertyTypes' in value) || value['propertyTypes'] === undefined) return false;
    return true;
}

export function PropertyTypeTreeDtoFromJSON(json: any): PropertyTypeTreeDto {
    return PropertyTypeTreeDtoFromJSONTyped(json, false);
}

export function PropertyTypeTreeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeTreeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyTypes': ((json['propertyTypes'] as Array<any>).map(PropertyTypeDtoFromJSON)),
    };
}

export function PropertyTypeTreeDtoToJSON(json: any): PropertyTypeTreeDto {
    return PropertyTypeTreeDtoToJSONTyped(json, false);
}

export function PropertyTypeTreeDtoToJSONTyped(value?: PropertyTypeTreeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyTypes': ((value['propertyTypes'] as Array<any>).map(PropertyTypeDtoToJSON)),
    };
}

